$(function() {

  setTimeout(function() {
    console.log($(document).height());
  }, 1000);

  var $window = $(window);
 
  $(window).on('scroll', function() {
    $topOffset = $(this).scrollTop();

    // console.log($(document).height());
    // console.log($topOffset);
    var difr = $(document).height() - $topOffset;
    // console.log(difr);

    if (difr < 1000) {
      $('.header__inline-menu').addClass('hit-bottom');
    } else {
      $('.header__inline-menu').removeClass('hit-bottom');      
    }
 
  });

  $('.list-social li').each(function() {
    $(this).find('a').attr('target', '_blank');
  });

  if (window.location.href == 'https://crystalreneehayslett.com/' || window.location.href == 'https://0z8yiyr1xzl9263v-62213161091.shopifypreview.com/') {
    $('body').addClass('home');

    // $('.home .videos-section').slick({
    //   centerMode: true,
    //   centerPadding: '30px',
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 5000,
    //   prevArrow: '<svg type="button" class="slick-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>',
    //   nextArrow: '<svg type="button" class="slick-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>',
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         arrows: false,
    //         centerMode: true,
    //         centerPadding: '40px',
    //         slidesToShow: 3
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         arrows: false,
    //         centerMode: true,
    //         centerPadding: '40px',
    //         slidesToShow: 1
    //       }
    //     }
    //   ]
    // });
  
  }

  if (window.location.href.indexOf('/pages/press') > -1) {
    $('body').addClass('press-page');

    if (!Modernizr.touchevents) {
      $('.c-follow-cursor__links li a').hover(function() {
        $('body').addClass('press-fade');
      }, function() {
        $('body').removeClass('press-fade');
      });
    }
  }

  if (window.location.href.indexOf('/collections/shop') > -1) {
    $('body').addClass('shop-page');
  }

  if (window.location.href.indexOf('/pages/tour') > -1) {
    $('body').addClass('tour-page');
  }

  
  
});